/**
 * Hazel's Pre-Order Lead Capture, RedTrack Tracking & Confirmation Engine
 * Native Shopify Customer Form Submission with contact[accepts_marketing] and Guaranteed Tracking.
 */

(function () {
  'use strict';

  function getClickID() {
    try {
      var params = new URLSearchParams(window.location.search);
      var q =
        params.get('clickid') ||
        params.get('rtkcid') ||
        params.get('rtkclickid') ||
        params.get('click_id') ||
        params.get('rtk_cid');

      if (q) {
        try {
          sessionStorage.setItem('hazels_clickid', q);
          localStorage.setItem('hazels_clickid', q);
        } catch (e) {}
        return q;
      }

      var cookieNames = ['rtkclickid-store', 'rtkclickid', 'rtkcid', '_rtkcid', 'hazels_clickid', 'clickid'];
      for (var i = 0; i < cookieNames.length; i++) {
        var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + cookieNames[i] + '=([^;]*)'));
        if (m && m[1]) return decodeURIComponent(m[1]);
      }
      for (var j = 0; j < cookieNames.length; j++) {
        var ls = localStorage.getItem(cookieNames[j]) || sessionStorage.getItem(cookieNames[j]);
        if (ls) return ls;
      }
      if (window.rtkClickID) return window.rtkClickID;
    } catch (e) {}
    return '';
  }

  // Persist Click ID immediately on script load
  getClickID();

  function fireRedTrackLead(email, name, storedClickId) {
    try {
      var clickid = storedClickId || getClickID();
      var tid = 'lead_' + (clickid || Date.now());

      var postbackUrl =
        'https://track.tryhazels.com/postback' +
        '?ptoken=ddhbgwzj7w' +
        '&type=' + encodeURIComponent('Lead') +
        (clickid ? '&clickid=' + encodeURIComponent(clickid) : '') +
        '&tid=' + encodeURIComponent(tid) +
        (email ? '&email=' + encodeURIComponent(email) : '') +
        (name ? '&first_name=' + encodeURIComponent(name) : '');

      console.log('[RedTrack Lead Event Fired]', postbackUrl);

      // Dispatch via exactly ONE reliable transport (sendBeacon -> fetch -> Image)
      if (navigator && typeof navigator.sendBeacon === 'function') {
        navigator.sendBeacon(postbackUrl);
      } else if (typeof fetch === 'function') {
        fetch(postbackUrl, { method: 'GET', keepalive: true, mode: 'no-cors' }).catch(function () {});
      } else {
        var img = new Image();
        img.src = postbackUrl;
      }
    } catch (e) {
      console.error('RedTrack Lead event error:', e);
    }
  }

  window.fireRedTrackLead = fireRedTrackLead;

  // Confirmation Page Tracking (/pages/order-update)
  function handleConfirmationPageTracking() {
    try {
      var rawLead = sessionStorage.getItem('hazels_pending_lead');
      var alreadyTracked = sessionStorage.getItem('hazels_lead_tracked');

      if (rawLead && !alreadyTracked) {
        sessionStorage.setItem('hazels_lead_tracked', 'true');
        var lead = JSON.parse(rawLead);
        console.log('Processing Lead Event on Confirmation Page:', lead);
        fireRedTrackLead(lead.email, lead.name || lead.firstName, lead.clickId);
        sessionStorage.removeItem('hazels_pending_lead');
      }
    } catch (e) {
      console.error('Confirmation page tracking error:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleConfirmationPageTracking);
  } else {
    handleConfirmationPageTracking();
  }

  // Pre-Order Form Submission Listener
  document.addEventListener('submit', function (event) {
    var targetForm = event.target;
    if (!targetForm) return;

    var isPreorderForm =
      targetForm.id === 'preorder-drawer-form' ||
      targetForm.id === 'preorder-form' ||
      targetForm.id === 'preorder-contact-form' ||
      targetForm.classList.contains('preorder-drawer__form') ||
      targetForm.classList.contains('preorder-form');

    if (!isPreorderForm) return;

    var nameEl =
      document.getElementById('preorder-drawer-name') ||
      document.getElementById('preorder-drawer-first-name') ||
      targetForm.querySelector('[name="contact[first_name]"], [name="contact[name]"]');

    var emailEl =
      document.getElementById('preorder-drawer-email') ||
      targetForm.querySelector('[name="contact[email]"]');

    var marketingEl = targetForm.querySelector('[name="contact[accepts_marketing]"]');
    var isMarketingOptIn = marketingEl ? marketingEl.value === 'true' || marketingEl.checked : true;

    var name = nameEl ? nameEl.value.trim() : '';
    var email = emailEl ? emailEl.value.trim() : '';
    var currentClickId = getClickID();

    // 1. Save pending lead data to fire on confirmation page (/pages/order-update)
    try {
      sessionStorage.setItem(
        'hazels_pending_lead',
        JSON.stringify({
          email: email,
          name: name,
          firstName: name,
          marketingConsent: isMarketingOptIn,
          clickId: currentClickId,
          submittedAt: Date.now()
        })
      );
      sessionStorage.removeItem('hazels_lead_tracked');
    } catch (e) {}

    // 3. Fire PostHog Event immediately
    if (window.posthog) {
      try {
        posthog.capture('register_interest_submitted', {
          email: email,
          name: name,
          first_name: name,
          opted_in_marketing: isMarketingOptIn
        });
      } catch (e) {}
    }

    var button = targetForm.querySelector('button[type="submit"]');
    if (button) {
      var label = button.querySelector('span');
      if (label) label.textContent = 'Registering…';
    }
  }, false);
})();